import _ from "lodash";
import { GRADING_PERIOD_CUMULATIVE } from "Constants/stringConstants";
import moment from "moment";

export const getCurrentTerm = _.memoize(
  ({ terms }) => {
    const currentDate = moment();

    // filter out cumulative terms
    const nonCumulativePeriods = _.filter(
      terms,
      term => _.get(term, "type") !== GRADING_PERIOD_CUMULATIVE
    );

    // find current term
    let currentTerm = _.find(nonCumulativePeriods, term => {
      const startDate = moment(_.get(term, "startDate"));
      const endDate = moment(_.get(term, "endDate"));
      if (currentDate >= startDate && currentDate <= endDate) {
        return true;
      }
    });

    // find nearest term if current term is not found
    if (_.isEmpty(currentTerm)) {
      let minDifference = Infinity;
      _.forEach(nonCumulativePeriods, term => {
        const startDate = moment(_.get(term, "startDate"));
        const endDate = moment(_.get(term, "endDate"));

        const difference1 = Math.abs(moment(currentDate).diff(startDate));
        const difference2 = Math.abs(moment(currentDate).diff(endDate));

        if (difference1 < minDifference || difference2 < minDifference) {
          minDifference = Math.min(difference1, difference2);
          currentTerm = term;
        }
      });
    }

    return !_.isEmpty(currentTerm) ? currentTerm : null;
  },
  ({ terms }) => {
    let cacheKey = "";
    _.forEach(
      terms,
      ({ id, startDate, endDate }) =>
        (cacheKey += `${id},${startDate},${endDate}|`)
    );

    return cacheKey;
  }
);
